<template>
    <div class="chat-container w-100 position-relative" style="margin-bottom: -30px;">
      <div class="position-relative" v-if="scrollPosition> 180">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-top d-block nav-bottom">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="container px-4 bg-white">
                    <div class="w-100">
                      <div class="row no-gutters">
                        <div class="col-10 pt-2 pb-2">
                          <div class="d-inline-block align-middle py-2 mr-2 cursor-pointer" @click="backToHome()">
                            <img src="../../assets/img/icon/back.png" width="25">
                          </div>
                          <div class="d-inline-block w-75 align-middle">
                            <p class="body-1-2 mb-0 d-block text-truncate">
                              {{getMerchant().name}}
                            </p>
                          </div>
                        </div>
                        <div v-if="show_btn_review" class="col-2 text-right" @click="giveReview()">
                          <div class="position-relative" style="top: 10px;">
                            <img src="../../assets/img/icon/edit-green.png" class="ml-1" width="15">
                          </div>
                        </div>
                      </div>
                      <!-- <div class="pb-2">
                        <input type="text" class="form-control border body-2-1 ls-0-1 search-custom" :placeholder="$t('general.search-review')" v-model="feedbacks.search" @keyup.enter="loadMerchantFeedback">
                      </div> -->
                    </div>
                  </div>
                  <div class="pt-3 bg-white border-bottom border-top">
                   <!--  <flickity ref="flickity" class="" :options="categorySlide">
                      <div class="carousel-cell pr-4" style="width:fit-content;" v-for="(data,index) in category" :class="{'pl-4':index == 0,'pr-4':index == category.length - 1}" @click="toggleCategory(data.title)">
                        <div class="w-100">
                          <p class="mb-0 body-3-3 text-15 pb-3 px-1" :class="{'font-bold text-green border-bottom-green-2':is_category_active == data.title}">{{data.title}}</p>
                        </div>
                      </div>
                    </flickity> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <top-navbar v-if="scrollPosition <= 180" title="Review" :url="'/'+getMerchant().code" />
      <div class="pt-3 border-bottom" style="margin-top: 42px;">
        <!-- <flickity ref="flickity" class="" :options="categorySlide">
          <div class="carousel-cell pr-4" style="width:fit-content;" v-for="(data,index) in category" :class="{'pl-4':index == 0,'pr-4':index == category.length - 1}" @click="toggleCategory(data.title)">
            <div class="w-100">
              <p class="mb-0 body-3-3 text-15 pb-3 px-1" :class="{'font-bold text-green border-bottom-green-2':is_category_active == data.title}">{{data.title}}</p>
            </div>
          </div>
        </flickity> -->
      </div>
      <div class="container px-4">
        <div class="pb-3 mb-2 pt-3" style="border-bottom: 2px solid #dee2e6">
          <div class="pt-2">
            <div class="row slim-grid-row">
              <div class="col-12">
                <p class="mb-0 heading-5 text-color-dark">{{getMerchant().name}}</p>
                <p class="mb-0 body-2-2-1 text-color-dark">{{getMerchant().address}}</p>
              </div>
            </div>
            <div class="row slim-grid-row" v-if="!loader && is_category_active == 'Website'">
              <div class="col-6">
              <div class="d-inline-block align-middle">
                <star-rating 
                  class="mt-1-"
                  :star-size="12"
                  active-color="#fbc632"
                  border-color="#fff" 
                  :increment="0.5"
                  :rating="summary.average"
                  :read-only="true"
                  :show-rating="false"
                  :rounded-corners="true"
                  :border-width="1"
                  :padding="2">    
                </star-rating>
              </div>
              <p class="mb-0 body-2 d-inline-block"> ({{summary.total}}) {{$t('general.reviews')}}</p>
              </div>
              <div class="col-6" v-if="show_btn_review">
                <div class="text-right">
                  <button class="border-green rounded pb-1 px-2 bg-white mt-2" @click="giveReview()">
                    <img src="../../assets/img/icon/edit-green.png" width="12" class="d-inline-block">
                    <p class="mb-0 pl-1 d-inline-block body-2 text-green">{{$t('general.give-a-feedback')}}</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <loader v-if="loader" />
        <template>
          <div class="row py-2">
            <div class="col-12">
              <input type="text" class="form-control border body-2-1 ls-0-1 search-custom" :placeholder="$t('general.search-review')" v-model="feedbacks.search" @keyup.enter="loadMerchantFeedback">
            </div>
          </div>
          <template v-if="feedbacks.list.length > 0">
            <div class="p-3 d-block" id="warning_msg" v-if="warning.show">
              <router-link :to="warning.link">
                <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
                  <div class="row grid-slim-row">
                    <div class="col-12 text-center">
                      <p class="mb-0 body-3-1">{{warning.message}}<br><span class="text-green">{{warning.highlight}}</span></p>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <template>
              <div class="px-2 mt-3 pt-1" v-for="feedback in feedbacks.list">
                <div class="border-bottom">
                  <div class="w-100 mb-2">
                    <div class="d-inline-block mr-2 align-middle" style="-webkit-writing-mode: vertical-lr;">
                      <img :src="feedback.avatar" class="rounded-50 object-fit" width="60" height="60">
                    </div>
                    <div class="d-inline-block align-middle">
                      <p class="mb-0 body-1 text-color-dark" v-if="getMerchant().merchant_type == 'ticket'">{{feedback.first_name}} {{feedback.last_name}}</p>
                      <p class="mb-0 body-1 text-color-dark" v-if="getMerchant().merchant_type == 'restaurant'">{{feedback.name}}</p>
                      <p class="mb-0 body-3">{{formatDate(feedback.created_at)}}</p>
                      <star-rating 
                        class="mt-1-"
                        :star-size="12"
                        active-color="#fbc632"
                        border-color="#fff" 
                        :increment="1"
                        :rating="feedback.star"
                        :read-only="true"
                        :show-rating="false"
                        :rounded-corners="true"
                        :border-width="1"
                        :padding="2">    
                      </star-rating>
                    </div>
                  </div>
                  <template v-if="feedback.image.length > 0">
                    <div class="row slim-grid-row my-2" v-if="feedback.image.length < 3">
                      <div :class="{'col-12': feedback.image.length == 1, 'col-6' : feedback.image.length == 2}" v-for="feed_img in feedback.image">
                        <img :src="feed_img.image_url" class="object-fit rounded w-100" height="200">
                      </div>
                    </div>
                    <div class="w-100 mt-2 mb-4" v-else>
                      <flickity ref="flickity" :options="flickityOptions">
                        <div class="carousel-cell w-100" v-for="feed_img in feedback.image">
                          <div class="w-100" style="height:200px !important;">
                            <img :src="feed_img.image_url" class="img-fit rounded">
                          </div>
                        </div>
                      </flickity>
                    </div>
                  </template>
                  <p class="body-2-2 pt-3 font-regular">{{feedback.message}}</p>
                  <div class="bg-light mt-2 mb-3 py-2 px-3 rounded" v-if="feedback.merchant_reply != null">
                    <div class="d-inline-block">
                      <p class="mb-0 body-1 text-color-dark text-14 mt-1">{{feedback.merchant_name}} <img src="../../assets/img/icon/success.png" width="12" class="d-inline-block"></p>
                      <p class="mb-0 body-3">{{formatDate(feedback.merchant_reply_time)}}</p>
                    </div>
                    <p class="body-2-2 pt-2 font-regular">{{feedback.merchant_reply}}</p>
                  </div>
                </div>
              </div>
              <infinite-loading v-if="feedbacks.last_page > 1" :forceUseInfiniteWrapper="true" spinner="spiral" @infinite="loadPagination">
                <div slot="no-more"> </div>
                <div slot="no-results"> </div>
              </infinite-loading>
            </template>
          </template>
          <div class="container text-center mt-8 text-white" v-else>
            <img src="../../assets/img/icon/namaste.png" width="250">
            <p class="pt-3 heading-4 text-22 mb-2 w-75 mx-auto">{{$t('warning-message.feedback.search.title')}}</p>
            <p class="body-2 mb-4 mx-auto">{{$t('warning-message.feedback.search.desc')}}</p>
            <div id="warning_msg">
              <div class="p-3 d-block mb-3" id="warning_msg" v-if="warning.show">
                <router-link :to="warning.link">
                  <div class="p-3 border radius-0" style="background-color: rgb(255, 243, 243);border-color: #feb8b8 !important;">
                    <div class="row grid-slim-row">
                      <div class="col-12 text-center">
                        <p class="mb-0 body-3-1">{{warning.message}}<br><span class="text-green">{{warning.highlight}}</span></p>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <button v-if="show_btn_review" class="border-green rounded py-2 px-4 bg-green" @click="giveReview()">
              <img src="../../assets/img/icon/edit-white.png" width="15" style="vertical-align: baseline;">
              <p class="mb-0 pl-1 d-inline-block body-2 text-white" style="vertical-align: text-top;">{{$t('general.give-a-feedback')}}</p>
            </button>
          </div>
        </template>
        <!-- OTA REVIEW -->
        <!-- <div v-if="is_category_active == 'Booking.com'">
          <p>Booking.com</p>
          <div class="elfsight-app-c0ef8f84-cc43-4050-ac9f-9065eb5181d1"></div>
        </div>
        <div v-if="is_category_active == 'Airbnb'">
          <p>airbnb</p>
          <div class="commonninja_component pid-b4633e93-0037-4042-9e6a-9cd835fda4ff"></div>
        </div>
         <div v-if="is_category_active == 'Google'">
          <p>google</p>
          <div class="elfsight-app-bd589ee7-0e5b-45f2-aed0-3fecd054980c"></div>
        </div> -->
      </div>
      <div class="w-100 d-block bg-white" style="height: 100px !important;">
      </div>
    </div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {get} from '@/services/index.js';
  import {mapGetters} from 'vuex';
  import {formatDate} from '@/utils/index.js'
  export default{
    components:{
      Flickity
    },
    data() {
      return {
        scrollPosition: null,
        flickityOptions: {
          initialIndex: 0,
          prevNextButtons: false,
          pageDots: true,
          wrapAround: true,
          adaptiveHeight: true,
        },
        loader: true,
        feedbacks:{
          search: '',
          list: [],
          page: 1,
          last_page: 1
        },
        summary:{},
        alerady_reviewed: false,
        show_not_login: false,
        total_trx: 0,
        warning:{
          show: false,
          message: '',
          highlight: '',
          link: ''
        },
        is_category_active: "Website",
        category:
        [
          {
            id:1,
            title: "Website",
            active: true
          },
          {
            id:2,
            title: "Booking.com",
            active: false
          },
          {
            id:3,
            title: "Airbnb",
            active: false
          },
          {
            id:4,
            title: "Google",
            active: false
          },
        ],
        categorySlide: {
          initialIndex: 0,
          autoPlay: false,
          prevNextButtons: false,
          pageDots: false,
          cellAlign: 'left',
          groupCells: true,
          draggable: true,
          wrapAround: false,
          contain: true,
        },
      }
    },
    computed:{
      user_validate(){
        let data = false
        if(this.getMerchant().merchant_type == 'ticket'){
          data = this.isNotLogin()
        }else if(this.getMerchant().merchant_type == 'restaurant'){
          data = this.getRestaurantAuth().session === ''
        }
        return data
      },
      show_btn_review(){
        let data = false
        if (this.user_validate) {
          data = true
        }else{
          if (this.alerady_reviewed == false) {
            data = true
          }
        }
        return data
      }
    },
    methods: {
      ...mapGetters(['getMerchant','token','isNotLogin','getRestaurantAuth']),
      formatDate(date){
        return formatDate(date);
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      loadMerchantFeedback(){
        this.loader = true
        this.warning.show = false
        let params = {
          module: "CORE",
          uri: "merchant-ticket-feedback",
          data: {
            merchant: this.getMerchant().id,
            keyword: this.feedbacks.search,
            page: 1,
            page_size: 5
          },
          session: null
        }

        if(this.getMerchant().merchant_type == 'restaurant'){
          params = {
            module: "CORE_RESTO",
            uri: "v2/merchant-feedback",
            data:{
              merchant_id: this.getMerchant().id,
              keyword: this.feedbacks.search,
              page: 1,
              page_size: 5
            },
            session: "restaurant_session"
          }
        }

        get(params.module,params.uri,params.data,params.session).then(response=>{
          let res = response.data
          if (res.success) {
            this.summary = res.data.feedback_summary
            this.feedbacks.list = res.data.all_feedback.data
            this.feedbacks.page = res.data.all_feedback.current_page
            this.feedbacks.last_page = res.data.all_feedback.last_page
            this.alerady_reviewed = res.data.already_give_feedback
            this.loader = false
          }
        })
      },
      loadPagination($state){
        if ((this.feedbacks.page+1) > this.feedbacks.last_page) {
          $state.complete();
        }else{
          get("CORE", "merchant-ticket-feedback", {
            merchant: this.getMerchant().id,
            keyword: this.feedbacks.search,
            page: this.feedbacks.page+1,
            page_size: 5
          }).then(response => {
            let res = response.data
            for (let i = 0; i < res.data.all_feedback.data.length; i++) {
              this.feedbacks.list.push(res.data.all_feedback.data[i])
            }
            this.feedbacks.page = res.data.all_feedback.current_page
            this.feedbacks.last_page = res.data.all_feedback.last_page
            this.alerady_reviewed = res.data.already_give_feedback
            $state.loaded();
          })
        }
      },
      giveReview(){
        if (this.user_validate) {
          this.show_not_login = true
          if(this.getMerchant().merchant_type == 'ticket'){
            this.warning = {
              show: true,
              message: this.$t('warning-message.feedback.login'),
              highlight: this.$t('general.login-now'),
              link: '/'+this.getMerchant().code+'/login'
            }
          }else{
            this.warning = {
              show: true,
              message: "You don't have session",
              highlight: "Create transaction to start new session",
              link: '/'+this.getMerchant().code
            }
          }
        }else{
          if (this.total_trx == 0) {
            this.warning = {
              show: true,
              message: this.$t('warning-message.feedback.order'),
              highlight: this.$t('ticket-cart.empty-cart.button'),
              link: this.getMerchant().merchant_type == 'ticket' ? '/'+this.getMerchant().code+'/list' : '/'+this.getMerchant().code
            }
          }else{
            this.$router.push({
              path: '/'+this.getMerchant().code+'/give-feedback'
            })
          }
        }
      },
      getTotalTrx(){
        let params = {
          module:"CORE",
          uri: `tx-ticket-count/${this.getMerchant().id}`,
          data: {},
          session: null
        }

        if(this.getMerchant().merchant_type == 'restaurant'){
          params = {
            module:"CORE_RESTO",
            uri: `v2/tx-count`,
            data: {merchant_id:this.getMerchant().id},
            session: "restaurant_session"
          }
        }
        get(params.module,params.uri,params.data,params.session).then(response=>{
          let res = response.data
          if (res.success) {
            this.total_trx = res.data
          }
        })
      },
      backToHome(){
        this.$router.push(`/${this.getMerchant().code}`)
      },
      toggleCategory(data){
        this.is_category_active = data
        console.log("category",this.is_category_active)
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      this.loadMerchantFeedback()
      if (!this.user_validate) {
        this.getTotalTrx()
      }
      // plugin
      let elfsightScript = document.createElement('script')
      elfsightScript.setAttribute('src', 'https://apps.elfsight.com/p/platform.js')
      document.head.appendChild(elfsightScript)

      let commoninjaScript = document.createElement('script')
      commoninjaScript.setAttribute('src', 'https://cdn.commoninja.com/sdk/latest/commonninja.js')
      document.head.appendChild(commoninjaScript)
    }
  }
</script>
<style scoped>
  .mt-1-{
    margin-top: -8px !important;
  }
	.search-custom {
    background-image: url('../../assets/img/icon/search.png');
    height: 43px;
    background-color: #fff !important;
    background-position: 16px 12px;
    background-size: 15px 15px;
    -o-object-fit: cover;
    object-fit: cover;
    background-repeat: no-repeat;
    padding: 5px 30px 7px 44px;
  }

  .flickity-page-dots .dot {
    width: 7px !important;
    height: 7px !important;
  }

  .logo-img{
    width: 75px;
  }

  @media screen and (max-width: 408px) {
    
    .logo-img{
      width: 60px!important;
    }

  }
</style>


// WEBPACK FOOTER //
// src/pages/general/Feedback.vue